import { copyArr } from "core/iterable_utils";
import { OffersDetailEnum } from "pages/Som/SomItem/SomItemLeft/components/SomItemOffers/SomItemOffersDetails";

export const updateSomOffer = ({ state, payload }) => {
	const changeInfo = payload?.change_info;

	const offers = copyArr(payload.offers).map((row) => {
		if (state.offerKeysWithExpandedJusts.includes(row.key)) {
			row.show_details = OffersDetailEnum.JUSTIFICATIONS;
		} else if (state.offerKeysWithExpandedCompany.includes(row.key)) {
			row.show_details = OffersDetailEnum.COMPANY;
		}
		if (state.somOfferPriceOfferDb.som_item_offer_id) {
			if (state.somOfferPriceOfferDb.som_item_offer_id === row?.id) {
				row.selected = true;
			}
		}
		if (["ADD", "EDIT"].includes(changeInfo?.action) && changeInfo?.object_type === "offer") {
			if (changeInfo.object_id === row?.id) {
				row.selected = true;
			} else {
				row.selected = false;
			}
		}
		return row;
	});
	return offers;
};
